import { render, staticRenderFns } from "./CourseBuilder.vue?vue&type=template&id=3a257d84&"
import script from "./CourseBuilder.vue?vue&type=script&lang=js&"
export * from "./CourseBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports